import { render } from "./CombatLogChartPanel.vue?vue&type=template&id=39d66b92"
import script from "./CombatLogChartPanel.vue?vue&type=script&lang=js"
export * from "./CombatLogChartPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__